/** Geschätzter offener Betrag: dieselbe Schraffur im Kapital-Panel und auf den Karten. */
export const schraffur = {
  backgroundImage: "repeating-linear-gradient(135deg, var(--ink-2) 0px, var(--ink-2) 1px, transparent 1px, transparent 5px)",
};
